module.exports = __webpack_public_path__ + "img/fire_grey_en.1855a5a1.svg";